import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SharedGridPage from "./SharedGridPage";
import AddEditKnowledgeDocument from "../components/knowledgeDocuments/AddEditKnowledgeDocument/AddEditKnowledgeDocument";

const ManageKnowledgeDocument: FC = () => {
    const { t } = useTranslation();
    const { documentId } = useParams();

    return (
        <SharedGridPage
            title={documentId ? t("KnowledgeDocument.EditDocument") : t("KnowledgeDocument.AddDocument")}
            subComponent={<AddEditKnowledgeDocument />}
        />
    );
};

export default ManageKnowledgeDocument;
